import { Button } from '@/components/ui/button';

interface Referral {
  referral_id: number;
  referred_email: string;
  created_at: string;
  resend_count: number;
}

interface ResendModalProps {
  isOpen: boolean;
  selectedReferral: Referral | null;
  resendLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ResendModal = ({ 
  isOpen, 
  selectedReferral, 
  resendLoading, 
  onClose, 
  onConfirm 
}: ResendModalProps) => {
  if (!isOpen || !selectedReferral) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-md shadow-lg border border-gray-200 dark:border-gray-700">
        {/* Header do Modal */}
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
            Confirmar reenvio
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Você tem certeza que deseja reenviar o email de ativação?
          </p>
        </div>

        {/* Conteúdo do Modal */}
        <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4 mb-6">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-8 h-8 bg-gray-200 dark:bg-gray-600 rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-gray-700 dark:text-gray-300 text-sm font-medium">
                {selectedReferral.referred_email[0].toUpperCase()}
              </span>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900 dark:text-white break-words">
                {selectedReferral.referred_email}
              </p>
            </div>
          </div>
          
          <div className="text-xs text-gray-500 dark:text-gray-400 ml-11">
            Tentativas de reenvio: {selectedReferral.resend_count}/2
          </div>
        </div>

        {/* Botões de Ação */}
        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            onClick={onClose}
            variant="outline"
            size="sm"
            className="flex-1 text-sm"
          >
            Cancelar
          </Button>
          <Button
            onClick={onConfirm}
            disabled={resendLoading || selectedReferral.resend_count >= 2}
            size="sm"
            className={`flex-1 text-sm ${
              resendLoading 
                ? 'bg-[#FFD200]/70 text-gray-900 cursor-wait'
                : 'bg-[#FFD200] hover:bg-[#FFB800] text-gray-900 font-medium'
            }`}
          >
            {resendLoading ? (
              <div className="flex items-center justify-center gap-2">
                <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Enviando...
              </div>
            ) : 'Confirmar reenvio'}
          </Button>
        </div>

        {/* Nota informativa */}
        <div className="mt-4 p-3 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg border border-yellow-200 dark:border-yellow-800">
          <p className="text-xs text-yellow-800 dark:text-yellow-300">
            Um novo email de ativação será enviado. Peça para o destinatário verificar a caixa de spam.
          </p>
        </div>
      </div>
    </div>
  );
};